export const sidebarTranslations = {
  en: {
    home: "Home",
    profileList: "Profile list",
    athletes: "Athletes",
    managers: "Managers",
    readyRoster: "Ready Roster",
    opportunities: "Opportunities",
    chat: "Chat",
    history: "History",
    abuseReport: "Abuse Report",
    settings: "Settings",
    accountSettings: "Account settings",
    logout: "Logout",
    viewProfile: "View Profile",
    profile: "Profile",
    mydeals: "My Deals",
    feeds: "Feeds",
    marketplaceCards: "Marketplace Cards",
    events: "Events",
    notifications: "Notifications",
    knowledgeHub: "Knowledge hub",
  },
  de: {
    home: "Startseite",
    profileList: "Profilliste",
    athletes: "Athleten",
    managers: "Manager",
    readyRoster: "Bereitschaftsroster",
    opportunities: "Möglichkeiten",
    chat: "Unterhaltung",
    history: "Verlauf",
    abuseReport: "Missbrauchsbericht",
    settings: "Einstellungen",
    accountSettings: "Kontoeinstellungen",
    logout: "Abmelden",
    viewProfile: "Profil ansehen",
    profile: "Profil",
    mydeals: "Meine Angebote",
    feeds: "Beiträge",
    marketplaceCards: "Marktplatzkarten",
    events: "Veranstaltungen",
    notifications: "Benachrichtigungen",
    knowledgeHub: "Wissenszentrum",
  },
  hr: {
    home: "Početna",
    profileList: "Popis profila",
    athletes: "Sportaši",
    managers: "Menadžeri",
    readyRoster: "Spremni popis",
    opportunities: "Prilike",
    chat: "Razgovor",
    history: "Povijest",
    abuseReport: "Izvještaj o zloupotrebi",
    settings: "Postavke",
    accountSettings: "Postavke računa",
    logout: "Odjava",
    viewProfile: "Prikaži profil",
    profile: "Profil",
    mydeals: "Moje ponude",
    feeds: "Objave",
    marketplaceCards: "Kartice tržišta", 
    events: "Događanja",
    notifications: "Obavijesti",
    knowledgeHub: "Centar znanja",
  },
};
